import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import { UserDetails } from '../../models/userDetail.model';
import { OPTIONAL } from '../../constants/constant';
import * as _ from 'lodash';

@Component({
  selector: 'app-search-user-with-role',
  templateUrl: './search-user-with-role.component.html',
  styleUrls: ['./search-user-with-role.component.scss', '../input-textbox/input-textbox.component.scss']
})
export class SearchUserWithRoleComponent implements OnInit {

  @Input() labelName: string;
  @Input() subLabelName: string;
  @Input() inputFormControl: FormControl;
  @Input() placeHolder = 'Input Field Text';
  @Input() submitted = false;
  @Input() readOnlyMode = false;
  @Input() users: UserDetails[];
  @Input() multiSelection = false;
  @Input() hideLabel = false;
  @Input() showOptionalLabel = false;
  @Output() onSelectUser = new EventEmitter();
  model: any;
  searchTxt;
  OPTIONAL = OPTIONAL;
  usersList: UserDetails[];

  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.users && changes.users.currentValue) {
      this.users = changes.users.currentValue;
      this.usersList = _.cloneDeep(this.users);
    }
    if (changes.inputFormControl && changes.inputFormControl.currentValue) {
      this.inputFormControl.valueChanges.subscribe(response => {
        this.searchTxt = response;
        this.getUsers();
      });
    }
  }

  ngOnInit(): void {
  }

  get isRequiredField(): boolean {
    if (this.multiSelection) {
      return true;
    }

    if (!this.inputFormControl || !this.inputFormControl.validator) {
      return false;
    }

    const validator = this.inputFormControl.validator({} as AbstractControl);
    return (validator && validator.required);
  }

  public getUsers(): void {
    if (this.searchTxt) {
      this.users = this.usersList.filter(item => {
        return (item.firstName && item.firstName.toLowerCase().includes(this.searchTxt.toLowerCase())) ||
          (item.lastName && item.lastName.toLowerCase().includes(this.searchTxt.toLowerCase()));
      });
    }
  }

  public onSelect(user: UserDetails): void {
    if (!this.multiSelection) {
      this.searchTxt = `${user.firstName} ${user.lastName} - ${user.currentPosition}`;
      this.inputFormControl.setValue(this.searchTxt);
    } else {
      this.inputFormControl.setValue(null);
    }
    this.onSelectUser.emit(user);
  }

  public clear(): void {
    this.searchTxt = null;
    this.inputFormControl.setValue(null);
    this.onSelectUser.emit(null);
  }

}
